import { Suit } from './Suit';

export class Card {
    suit: Suit;
    number?: number;
    player?: number = 0;

    discardIndex?: number = undefined;
    knock: boolean = false;

    score: number; // deadwood score (used for AI)
    possibleMelds?: Card[][];

    constructor (suit: Suit, number?: number, player?: number) {
        this.suit = suit;
        this.number = number;
        this.player = player;
    }

    // toJSON () {
    //     return `${this.suit}-${this.number}`;
    // }
}


// WEBPACK FOOTER //
// ./src/playing-cards/Card.ts